import GreyCatLintError from './lint-error';
import { string2type } from './helper';
export default class Scope {
    constructor(_type, params = new Map()) {
        this._type = _type;
        this._stack = [];
        this._refs = new Map();
        this._unreachableRange = null;
        this._params = params;
    }
    push(scope) {
        this._stack.push(scope);
    }
    pop() {
        return this._stack.pop();
    }
    peek() {
        if (this._stack.length === 0) {
            return this;
        }
        return this._stack[this._stack.length - 1];
    }
    setRef(name, ref) {
        if (ref.value === undefined) {
            ref.value = null;
        }
        if (ref.value instanceof Scope) {
            ref.value._parent = this;
        }
        this._refs.set(name, ref);
    }
    getRef(name) {
        const ref = this._refs.get(name);
        if (ref === undefined && this._parent) {
            return this._parent.getRef(name);
        }
        return ref;
    }
    resolve(qName, ctx) {
        const qNameCopy = [...qName];
        const token = qNameCopy.shift();
        if (token) {
            let ref = this.getRef(token.image);
            if (ref === undefined) {
                if (ctx.strict) {
                    if (this._type !== 'any' && this._type !== 'node') {
                        ctx.errors.push(new GreyCatLintError(`Property '${token.image}' does not exist in '${this._type}'`, token));
                    }
                }
                else {
                    ref = { type: 'null', value: null, token };
                    this.setRef(token.image, ref);
                    return ref;
                }
            }
            else {
                if (qNameCopy.length === 0) {
                    return ref;
                }
                else {
                    if (ref.value instanceof Scope) {
                        return ref.value.resolve(qNameCopy, ctx);
                    }
                    else if (ref.value === null && qNameCopy.length > 0) {
                        ctx.errors.push(new GreyCatLintError(`Variable '${token.image}' is null, cannot read '${qNameCopy.map((q) => q.image).join('.')}' on it`, token));
                    }
                    else {
                        return ref;
                    }
                }
            }
        }
        return;
    }
    hasRef(name) {
        return this.getRef(name) !== undefined;
    }
    declareParam(name, type) {
        this._params.set(name, string2type(type));
    }
    getParamDecl(name) {
        return this._params.get(name);
    }
    startUnreachable({ startLine, startColumn, startOffset }) {
        this._unreachableRange = { startLine, startColumn, startOffset };
    }
    endUnreachable({ endLine, endColumn, endOffset }) {
        this._unreachableRange = Object.assign({}, this._unreachableRange, { endLine, endColumn, endOffset });
    }
    get type() {
        return this._type;
    }
    get params() {
        return this._params;
    }
    get unreachableRange() {
        return this._unreachableRange;
    }
    set parent(parent) {
        this._parent = parent;
    }
}
//# sourceMappingURL=scope.js.map